import { render, staticRenderFns } from "./OpenCompanyAccount.vue?vue&type=template&id=58e82ed6&"
import script from "./OpenCompanyAccount.vue?vue&type=script&lang=js&"
export * from "./OpenCompanyAccount.vue?vue&type=script&lang=js&"
import style0 from "./OpenCompanyAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports